import { ref } from 'vue'
import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage, ElMessageBox } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TOKEN_OVER_TIME_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'
import { encryptData, decryptData } from '@/api/data/common'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  config.headers['debug'] = '0'
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = {
      encryptKey: encryptData(qs.stringify(config.data))
    }
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data'
  ) {
    config.data = {
      encryptKey: encryptData(objToFormData(config.data))
    }
  } else if (
    (config.method === 'post' && config.headers['Content-Type'] === 'application/json') ||
    config.method === 'delete'
  ) {
    config.data = {
      encryptKey: encryptData(JSON.stringify(config.data))
    }
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const loading = ref(false)
const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 如果是文件流，直接过
    return response
  } else {
    // 解密操作
    const { data } = response
    let res
    if (data.encryptKey) {
      res = JSON.parse(decryptData(data.encryptKey))
    } else {
      res = data
    }
    if (res.code === SUCCESS_CODE) {
      return res
    } else {
      if (res.code === TOKEN_OVER_TIME_CODE) {
        ElMessageBox.confirm(
          '您已退出或登录超时, 您可以点击取消停留在当前页面, 或者跳转重新登录?',
          '提示',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(async () => {
          loading.value = true
          const userStore = useUserStoreWithOut()
          userStore.logout()
          loading.value = false
        })
      } else {
        ElMessage.error(res?.msg)
      }
    }
    // if (response?.data?.code === SUCCESS_CODE) {
    //   return response.data
    // } else {
    //   if (response?.data?.code === TOKEN_OVER_TIME_CODE) {
    //     ElMessageBox.confirm(
    //       '您已退出或登录超时, 您可以点击取消停留在当前页面, 或者跳转重新登录?',
    //       '提示',
    //       {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }
    //     ).then(async () => {
    //       loading.value = true
    //       const userStore = useUserStoreWithOut()
    //       userStore.logout()
    //       loading.value = false
    //     })
    //   } else {
    //     ElMessage.error(response?.data?.msg)
    //   }
    // }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
